import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SmartFilterRowViewModel } from '../smart-filter-row-view-model';

@Component({
  selector: 'app-smart-filters-row-misc-button',
  templateUrl: './smart-filters-row-misc-button.component.html',
  styleUrls: ['./smart-filters-row-misc-button.component.scss'],
  standalone: false
})
export class SmartFiltersRowMiscButtonComponent {
  @Input() text: string;
  @Input() iconSrc: string;
  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public viewModel: SmartFilterRowViewModel // provided by logged in scope
  ) {}

  buttonClicked() {
    this.clicked.emit();
  }
}
